import { useCallback, useState } from 'react';

export interface UseVoicemailDeleteDialogResult {
  dialogVisible: boolean;
  messageToDelete: number | null;
  onDeleteMessage: (message_id: number) => void;
  closeDialog: () => void;
}

// Encapsulates delete-dialog state and handler for selecting a voicemail to delete.
export const useVoicemailDeleteDialog = (): UseVoicemailDeleteDialogResult => {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [messageToDelete, setMessageToDelete] = useState<number | null>(null);

  const onDeleteMessage = useCallback((message_id: number) => {
    setMessageToDelete(message_id);
    setDialogVisible(true);
  }, []);

  const closeDialog = useCallback(() => {
    setDialogVisible(false);
    setMessageToDelete(null);
  }, []);

  return { dialogVisible, messageToDelete, onDeleteMessage, closeDialog };
};

